import styled from 'styled-components';

export default styled.div<{primaryColor?: string}>(
  ({theme, primaryColor}) => `
  --bg-color: rgba(0, 0, 0, 0.9);
  --primary-color: ${primaryColor ? primaryColor : '#444CE7'};
  --default-color: #fff;
  --hover-color: rgba(0, 0, 0, 1);
  --radius: 4px;

  --scrollbar-thumb: rgb(31, 31, 31);
  --scrollbar-track: transparent;
  --scrollbar-thumb-hover: rgb(64, 64, 64);
 	--scrollbar-width: 4px;

  --range-track-bg: rgba(255, 255, 255, 0.20);
  --range-track-height: 5px;
  --range-thumb-height: 8px;
  --range-thumb-background: #fff;
  --range-thumb-shadow: 0 1px 1px rgba(215, 26, 18, 0.15), 0 0 0 1px rgba(215, 26, 18, 0.2);
  --range-thumb-active-shadow-width: 3px;

  position: absolute;
  display: flex;
  justify-content: flex-end;
  bottom: 8px;
  top: 8px;
  right: 8px;
  width: 100%;
  pointer-events: none;

  will-change: transform;
  transition: transform .5s ease-in-out !important;
  transform: translateX(100%) !important;
  z-index: 0;

  .search__input,
  .search__closeButton {
    pointer-events: none;
    display: none;
  }

  &.search--opened {
    z-index: 90;
    pointer-events: auto;
    transform: translateX(0) !important;

    .search__input, .search__closeButton {
      pointer-events: all;
      display: flex;
    }
  }

  .search__backdrop {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    transition-delay: .2s;
    transition: all .3s ease-in-out;
  }

  .search__panel {
    margin: 0;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.90);
    pointer-events: auto;
    width: 100%;
    max-width: 455px;
    visibility: visible;
    opacity: 1;
    box-sizing: border-box;
    z-index: 90;

    @media (max-width: 768px) {
      max-width: calc(100% - 16px);
    }
  }

  .search__inputWrapper {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 8px;
    height: 40px;
    background: transparent;
    pointer-events: auto;
    position: sticky;
  }

  .search__input {
    height: 100%;
    width: 100%;
    border: 1px solid rgba(64, 64, 64, 1);
    border-radius: 4px;
    background: rgba(31, 31, 31, 1);
    padding: 8px 12px;

    color: rgba(245, 245, 245, 1);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
    box-sizing: border-box;

    &:focus {
      box-shadow: 0px 0px 0px 2px var(--primary-color);
      outline: transparent;
    }
  }

  .search__closeButton {
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    width: 40px;
    height: 40px;
    height: 100%;
    padding: 8px;
    border: 0;
    color: rgba(245, 245, 245, 1);
    background: rgba(31, 31, 31, 1);
    border-radius: 4px;
    cursor: pointer;
    transition: .3s ease-in-out background-color;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    outline: none;

    &:focus,
    &:hover {
      background: #404040;
      color: #fff;
      outline: none;
    }
  }

  .search__closeIcon {
    height: 12px;
    width: 12px;
    color: currentColor;
  }

  .search__panelWrapper {
    display: flex;
    padding: 8px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    gap: 8px;
    align-self: stretch;
    height: 100%;
    box-sizing: border-box;
  }

  .search__resultWrapper {
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    pointer-events: auto;
    gap: 8px;
    overflow-y: scroll;
    list-style: none;
    appearance: none;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  .search__resultItem {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    color: rgba(89, 89, 89, 1);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
    width: 100%;
    padding: 8px 8px 8px 12px;
    cursor: pointer;
    gap: 8px;
    border-radius: 4px;
    overflow-x: clip;
    transition: .3s color ease-in-out;
    box-sizing: border-box;

    p {
      text-align: left;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      color: #A0A0A0;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 140%;
      margin: 0px;
      padding-left: 5px;
      transition: .3s color ease-in-out;
    }

    span {
      display: flex;
      white-space: nowrap;
      height: 24px;
      padding: 4px 8px;
      align-items: center;
      border-radius: 4px;
      border: 1px solid rgba(31, 31, 31, 1);;
      background: rgba(31, 31, 31, 1);
      right: 0px;
      top: 0px;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 14px; /* 116.667% */
      color: rgba(89, 89, 89, 1);
      transition: .3s color ease-in-out, .3s background-color ease-in-out;
    }

    strong {
      color: var(--primary-color);
    }

    &:focus,
    &:hover {
      background: rgba(38, 38, 38, 1);

      p {
        color: rgba(255, 255, 255, 1);
      }

      span {
        color: rgba(255, 255, 255, 1);
        border: 1px solid rgba(64, 64, 64, 1);
        background: rgba(64, 64, 64, 1);
      }
    }
  }

  & > .search__panel {
    & > .search__panelWrapper {
      display: flex;
      padding: 8px;
      flex-direction: column;
      justify-content: center;
      align-items: flex-end;
      gap: 8px;
      align-self: stretch;
      height: 100%;

      & > div.scaleup-search__input-wrapper{


        & > .scaleup-search__input--close__button{

        }
      }

      & > .scaleup-search__results-wrapper {
        display: flex;
        width: 100%;
        height: 100%;
        flex-direction: column;
        pointer-events: auto;
        gap: 8px;
        overflow-y: scroll;

        & > .scaleup-search__results--list {
          display: flex;
          flex-direction: row;
          justify-content: space-between;

          color: rgba(89, 89, 89, 1);
          font-family: Inter;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 140%;

          width: 100%;
          padding: 8px 8px 8px 12px;
          cursor: pointer;
          gap: 8px;
          border-radius: 4px;
          overflow-x: clip;

          transition: .3s color ease-in-out;

          &>span{
            display: flex;
            white-space: nowrap;
            height: 24px;
            padding: 4px 8px;
            align-items: center;
            border-radius: 4px;
            border: 1px solid rgba(31, 31, 31, 1);;
            background: rgba(31, 31, 31, 1);
            right: 0px;
            top: 0px;

            font-family: Inter;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 14px; /* 116.667% */
            color: rgba(89, 89, 89, 1);
            transition: .3s color ease-in-out, .3s background-color ease-in-out;
          }

          & > p {
            text-align: left;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            color: var(--gray-dark-11, #A0A0A0);

            font-family: Inter;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 140%;
            margin: 0px;
            padding-left: 5px;
            transition: .3s color ease-in-out;
          }

          &:hover {
            background: rgba(38, 38, 38, 1);

            & > p {
              color: rgba(255, 255, 255, 1);
            }

            & > span {
              color: rgba(255, 255, 255, 1);
              border: 1px solid rgba(64, 64, 64, 1);
              background: rgba(64, 64, 64, 1);
            }
          }
        }
      }
    }
  }

  &:not(.search--opened) .scaleup-search__panel-wrapper {
    transition: visibility 0.5s ease-in-out, opacity 0.5s ease-in-out;
    opacity: 0;
    visibility: hidden;
  }
`);
